if (!customElements.get('featured-products-swiper')) {
    customElements.define('featured-products-swiper', class FeaturedProductsSwiper extends HTMLElement {
        constructor() {
            super();
            this.swiper = null;
            this.swiperContainer = null;
            this.swiperSlides = null;
        }

        connectedCallback() {
            this.swiperContainer = this.querySelector('.swiper');
            this.swiperSlides = this.querySelectorAll('.swiper-slide');
            if (!this.swiperContainer || !this.swiperSlides.length) return;

            this.initSwiper();
            // this.setupColorSwatches();
        }

        // setupColorSwatches() {
        //     this.swiperSlides.forEach(slide => {
        //         const targetInput = slide.querySelector('[data-type="add-to-cart-form"] [name="id"]');
        //         const colorSwatchContainer = slide.querySelector('.card_product-card__swatch');
        //         if (!targetInput || !colorSwatchContainer) return;
        
        //         // 处理色卡交互的通用函数
        //         const handleSwatchInteraction = (event) => {
        //             const swatchItem = event.target.closest('.color-swatch-item');
        //             if (!swatchItem) return;
        
        //             event.preventDefault();
                    
        //             const variantId = swatchItem.dataset.id;
        //             targetInput.value = variantId;
        
        //             // 更新色卡状态
        //             slide.querySelectorAll('.color-swatch-item').forEach(item =>
        //                 item.classList.toggle('active', item === swatchItem)
        //             );
        
        //             // 更新对应图片
        //             const imageContainer = slide.querySelector('.custom-product-card__image');
        //             if (imageContainer) {
        //                 imageContainer.classList.add('active');
        //                 imageContainer.querySelectorAll('.color_swatch_image__item').forEach(img =>
        //                     img.classList.toggle('active', img.dataset.id === variantId)
        //                 );
        //             }
        //         };
        
        //         // 桌面端 - 鼠标悬停时切换
        //         colorSwatchContainer.addEventListener('mouseover', handleSwatchInteraction, { passive: false });
                
        //         // 移动端 - 触摸时切换
        //         colorSwatchContainer.addEventListener('touchstart', handleSwatchInteraction, { passive: false });
        //     });
        // }
        

        initSwiper() {
            this.swiper = new Swiper(this.swiperContainer, {
                slidesPerView: 'auto',
                navigation: {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev'),
                },
            });
        }
    });
}